import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { EnvPropTypes, ExamplesPropTypes } from '../../propTypes/genericPropTypes';

import './examplePopup.scss';

export const ExamplePopup = ({ example, env = 'prod', onClose = () => {} }) => {
  const {
    type,
    heading,
    urls,
    imgCssClass,
    screenReader: { description: srDescription }
  } = example;

  return (
    <Panel
      type="modal"
      open
      size="large"
      customCssClass={`examplePopup ${type}`}
      header={{
        fixed: true,
        content: heading
      }}
      onClose={onClose}
    >
      {type === 'image' && (
        <img
          className={imgCssClass}
          src={urls[env]}
          alt={heading}
        />
      )}
      <span className="sr-only">{srDescription}</span>
    </Panel>
  );
};

ExamplePopup.propTypes = {
  example: ExamplesPropTypes,
  env: EnvPropTypes,
  onClose: PropTypes.func
};
